import React from 'react';
import NumberFormat from 'react-number-format';
import creditCardType from 'credit-card-type';
import {
  Card,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core';
import { states } from 'helpers/usStates';
import { setCardMask } from 'helpers/paymentCard';


const StepTree = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue
}) => {
  const {
    billingInformation: {
      ccNumber,
      ccCVV,
      firstName,
      lastName,
      streetAddress1,
      streetAddress2,
      city,
      zipCode,
      state,
      phone,
      company,
      expiry
    },
  } = values;

  const cardTypeInfo = ccNumber.length ? creditCardType(ccNumber)[0] : {};

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <Typography variant="h4" component="h4" className="h4 mb-5">
          Payment Setup
        </Typography>
        <Typography variant="body1">
          {`This page contain your card and billing
           address information used by our system to
            automatically renew your subscription.`}
        </Typography>
      </Grid>
      <Grid item xs={12} md={9}>
        <Card elevation={25} className="p-5 mb-5">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <NumberFormat
                customInput={TextField}
                format={setCardMask(cardTypeInfo?.gaps, cardTypeInfo?.lengths)}
                required
                className="w-full"
                variant="outlined"
                name="billingInformation.ccNumber"
                label="Credit Card Number"
                value={ccNumber}
                onChange={(event) => setFieldValue('billingInformation.ccNumber', event.target.value?.replace(/\s/g, ''))}
                onBlur={(event) => {
                  handleBlur(event);
                  setFieldValue('billingInformation.ccNumber', event.target.value?.replace(/\s/g, ''));
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <img
                        src={`/assets/images/paymentCards/${cardTypeInfo?.type ? cardTypeInfo.type : 'none'}.png`}
                        alt={cardTypeInfo?.type ? cardTypeInfo.type : 'unknown'}
                        className="h-40"
                      />
                    </InputAdornment>
                  )
                }}
                error={touched?.billingInformation?.ccNumber && Boolean(errors?.billingInformation?.ccNumber)}
                helperText={touched?.billingInformation?.ccNumber && errors?.billingInformation?.ccNumber}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <NumberFormat
                    customInput={TextField}
                    format="##/##"
                    mask="_"
                    required
                    className="w-full"
                    variant="outlined"
                    name="billingInformation.expiry"
                    label="Expiration Date"
                    value={expiry}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched?.billingInformation?.expiry && Boolean(errors?.billingInformation?.expiry)}
                    helperText={touched?.billingInformation?.expiry && errors?.billingInformation?.expiry}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <NumberFormat
                    customInput={TextField}
                    required
                    className="w-full"
                    variant="outlined"
                    name="billingInformation.ccCVV"
                    label="CVV"
                    value={ccCVV}
                    onChange={(event) => setFieldValue('billingInformation.ccCVV', event.target.value?.replace(/\s/g, ''))}
                    onBlur={(event) => {
                      handleBlur(event);
                      setFieldValue('billingInformation.ccCVV', event.target.value?.replace(/\s/g, ''));
                    }}
                    error={touched?.billingInformation?.ccCVV && Boolean(errors?.billingInformation?.ccCVV)}
                    helperText={touched?.billingInformation?.ccCVV && errors?.billingInformation?.ccCVV}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
        <Card elevation={25} className="p-5 mb-5">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} className="mb-5">
              <TextField
                fullWidth
                required
                variant="outlined"
                name="billingInformation.firstName"
                label="First Name"
                value={firstName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.billingInformation?.firstName && Boolean(errors?.billingInformation?.firstName)}
                helperText={touched?.billingInformation?.firstName && errors?.billingInformation?.firstName}
              />
            </Grid>
            <Grid item xs={12} md={6} className="mb-5">
              <TextField
                fullWidth
                required
                variant="outlined"
                name="billingInformation.lastName"
                label="Last Name"
                value={lastName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.billingInformation?.lastName && Boolean(errors?.billingInformation?.lastName)}
                helperText={touched?.billingInformation?.lastName && errors?.billingInformation?.lastName}
              />
            </Grid>
            <Grid item xs={12} md={6} className="mb-5">
              <TextField
                fullWidth
                required
                variant="outlined"
                name="billingInformation.streetAddress1"
                label="Address 1"
                value={streetAddress1}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.billingInformation?.streetAddress1 && Boolean(errors?.billingInformation?.streetAddress1)}
                helperText={touched?.billingInformation?.streetAddress1 && errors?.billingInformation?.streetAddress1}
              />
            </Grid>
            <Grid item xs={12} md={6} className="mb-5">
              <TextField
                fullWidth
                variant="outlined"
                name="billingInformation.streetAddress2"
                label="Address 2 (optional)"
                value={streetAddress2}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.billingInformation?.streetAddress2 && Boolean(errors?.billingInformation?.streetAddress2)}
                helperText={touched?.billingInformation?.streetAddress2 && errors?.billingInformation?.streetAddress2}
              />
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <TextField
                fullWidth
                required
                variant="outlined"
                name="billingInformation.city"
                label="City"
                value={city}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.billingInformation?.city && Boolean(errors?.billingInformation?.city)}
                helperText={touched?.billingInformation?.city && errors?.billingInformation?.city}
              />
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <TextField
                fullWidth
                required
                select
                variant="outlined"
                name="billingInformation.state"
                label="State"
                value={state}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.billingInformation?.state && Boolean(errors?.billingInformation?.state)}
                helperText={touched?.billingInformation?.state && errors?.billingInformation?.state}
              >
                {states.map((state) => (
                  <MenuItem key={state.value} value={state.value}>
                    {state.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <TextField
                fullWidth
                required
                variant="outlined"
                name="billingInformation.zipCode"
                label="Zip Code"
                value={zipCode}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.billingInformation?.zipCode && Boolean(errors?.billingInformation?.zipCode)}
                helperText={touched?.billingInformation?.zipCode && errors?.billingInformation?.zipCode}
              />
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <TextField
                fullWidth
                variant="outlined"
                name="billingInformation.country"
                label="Country"
                value="US"
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{ readOnly: true, shrink: 'true' }}
                error={touched?.billingInformation?.country && Boolean(errors?.billingInformation?.country)}
                helperText={touched?.billingInformation?.country && errors?.billingInformation?.country}
              />
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <NumberFormat
                customInput={TextField}
                format="(###) ###-####"
                mask="_"
                required
                className="w-full"
                label="Phone"
                variant="outlined"
                name="billingInformation.phone"
                value={phone}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.billingInformation?.phone && Boolean(errors?.billingInformation?.phone)}
                helperText={touched?.billingInformation?.phone && errors?.billingInformation?.phone}
              />
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <TextField
                fullWidth
                variant="outlined"
                name="billingInformation.company"
                label="Company"
                value={company}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.billingInformation?.company && Boolean(errors?.billingInformation?.company)}
                helperText={touched?.billingInformation?.company && errors?.billingInformation?.company}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default StepTree;
